const CHUNK_LOAD_RELOAD_KEY = 'cx-chunk-load-reloaded';

const CHUNK_LOAD_MESSAGE_PATTERNS = [
  /Loading chunk [\w-]+ failed/i,
  /ChunkLoadError/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Failed to load module script/i,
  /error loading ES module/i,
];

function collectErrorCandidates(error: unknown): unknown[] {
  const candidates: unknown[] = [error];
  const seen = new Set<unknown>([error]);

  const enqueue = (value: unknown): void => {
    if (value == null || seen.has(value)) {
      return;
    }
    seen.add(value);
    candidates.push(value);
  };

  for (const candidate of candidates) {
    if (!candidate || typeof candidate !== 'object') {
      continue;
    }

    const record = candidate as Record<string, unknown>;
    enqueue(record['rejection']);
    enqueue(record['reason']);
    enqueue(record['originalError']);
    enqueue(record['ngOriginalError']);
    enqueue(record['error']);
    enqueue(record['cause']);
  }

  return candidates;
}

function getErrorText(candidate: unknown): string {
  if (candidate == null) {
    return '';
  }

  if (typeof candidate === 'string') {
    return candidate;
  }

  if (typeof candidate !== 'object') {
    return String(candidate);
  }

  const record = candidate as Record<string, unknown>;
  return [record['name'], record['message'], record['stack']]
    .filter((part) => part != null)
    .map(String)
    .join(' ');
}

export function isChunkLoadError(error: unknown): boolean {
  return collectErrorCandidates(error).some((candidate) =>
    CHUNK_LOAD_MESSAGE_PATTERNS.some((pattern) => pattern.test(getErrorText(candidate)))
  );
}

export function tryRecoverFromChunkLoadError(error: unknown): boolean {
  if (!isChunkLoadError(error)) {
    return false;
  }

  try {
    if (sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY) != null) {
      return false;
    }
    sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, '1');
  } catch {
    return false;
  }

  window.location.reload();
  return true;
}
